import { render, staticRenderFns } from "./IconBookmarkAltSolid.vue?vue&type=template&id=8bb8fa2c"
import script from "./IconBookmarkAltSolid.vue?vue&type=script&lang=js"
export * from "./IconBookmarkAltSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports